// src/app/services/sw-update.service.ts
import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SwUpdateService {
  constructor(private swUpdate: SwUpdate) {}

  init(): void {
    if (!this.swUpdate.isEnabled) return;

    // 1. Vérifier au démarrage (après le délai d'enregistrement du SW)
    setTimeout(() => {
      this.swUpdate.checkForUpdate();
    }, 6000); // légèrement après le registerWithDelay:5000

    // 2. Vérifier toutes les 5 minutes
    interval(5 * 60 * 1000).subscribe(() => {
      this.swUpdate.checkForUpdate();
    });

    // 3. Dès qu'une nouvelle version est prête → recharger
    this.swUpdate.versionUpdates
      .pipe(filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY'))
      .subscribe(() => {
        document.location.reload();
      });

    // 4. Gérer les erreurs de SW (version non récupérable)
    this.swUpdate.unrecoverable.subscribe(() => {
      document.location.reload();
    });
  }
}
